import {selector, selectorFamily} from 'recoil';

import {
  currentUserAccountIdState,
  currentUserAccountState,
  userAccountsQueryTrigger,
  userAccountsState,
  userPageable,
  userSearchSortQueryTrigger,
  userSortQueryTrigger,
} from './atoms';

import {UserAccountService} from '../../api/services/user-account.service';
import {authState} from '../auth/atoms';
import {IUserAccountSpec, TypeAccountRoles} from '../../shared/types/user-account.types';

export const userAccountsQuery = selector({
  key: 'userAccountsQuery',
  get: async ({get}) => {
    const {user} = get(authState);
    get(userAccountsQueryTrigger);
    const pageable = get(userPageable);
    const search = get(userSearchSortQueryTrigger);
    const sort = get(userSortQueryTrigger);

    const isAdmin = user?.roles?.includes(TypeAccountRoles.ADMIN);
    const showOnlyActive = !user?.roles?.some(
      (i) => i === TypeAccountRoles.ADMIN || i === TypeAccountRoles.FUNCTIONAL_ADMIN,
    );

    const res = await UserAccountService.getAll({
      pageable: {
        ...pageable,
        order: [sort?.[0]?.field || 'id', sort?.[0]?.sort === 'asc' ? 'ASC' : 'DESC'],
      },
      spec: (isAdmin
        ? {
            fio: search,
          }
        : {
            fio: search,
            companyId: user?.companyId as string,
            ...(showOnlyActive ? {isActive: true} : {}),
          }) as IUserAccountSpec,
    });

    return res.data;
  },
  set: ({set}, newValue) => {
    set(userAccountsState, newValue);
  },
});

export const userAccountByIdQueryFamily = selectorFamily({
  key: 'userAccountByIdQueryFamily',
  get:
    (id: string) =>
    async ({get}) => {
      get(userAccountsQueryTrigger);

      if (!id) return null;

      const res = await UserAccountService.getById(id);

      return res.data;
    },
  set:
    () =>
    ({set}, newValue) => {
      set(currentUserAccountState, newValue);
    },
});

export const userAccountByIdQuery = selector({
  key: 'userAccountByIdQuery',
  get: async ({get}) => {
    get(userAccountsQueryTrigger);
    const id = get(currentUserAccountIdState);

    if (!id) return null;

    const res = await UserAccountService.getById(id);

    return res.data;
  },
  set: ({set}, newValue) => {
    set(currentUserAccountState, newValue);
  },
});

export const userAccountPhotoQueryFamily = selectorFamily({
  key: 'userAccountPhotoQueryFamily',
  get: (id: number) => async () => {
    // TODO: отключает фото до лучших времен
    return null;

    if (!id) return null;

    const res = await UserAccountService.getUserPhoto(id);

    const data = await res.blob();

    const url = URL.createObjectURL(data);

    return url;
  },
});
